.jx{right:0.25rem;}